export default __webpack_public_path__ + "static/media/ITRealCase1.940f71f3.jpg";